// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"account":"af2200ea","administration":"d0ad1ef7"}[chunkId] + ".chunk.js";
};